













import VueOptions from '@utils/VueOptions'
import Back from '@modules/ui/buttons/Back'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import ScannerForm from '@superUI/Forms/ScannerForm'
import RequestButton from '@components/RequestButton'

settings =
  name: "ScannerEdit"
  components: { Back, SuperContainerView, ScannerForm, RequestButton }
  resources:
    scanner:
      resourceName: "scanner"
      slug: "scanners/:scannerId/edit"
  vue:
    props: ['scannerId']
    methods:
      onSave: (item) -> @$router.push({ name: 'ScannerShowPage', params: { scannerId: item.id } })

export default VueOptions.vue settings
